/***************************************************************
 * districtNeighbors.js
 * 
 * Defines which districts are considered neighbors for cross-district
 * inspection assignments when inspectors are underutilized.
 ***************************************************************/

export const districtNeighbors = {
    "101": ["102", "103"],
    "102": ["101", "103", "104", "105", "106"],
    "103": ["101", "102", "105", "106"],
    "104": ["102", "106", "105", "107"],
    "105": ["102", "103", "106", "104", "107", "108"],
    "106": ["103", "102", "105", "108"],
    "107": ["104", "105", "109", "110", "111"],
    "108": ["106", "105", "111", "110"],
    "109": ["107", "110", "111", "112"],
    "110": ["111", "109", "112"],
    "111": ["108", "110", "109"],
    "112": ["109", "110", "111"],
    "201": ["202", "203", "204"],
    "202": ["201", "203", "209"],
    "203": ["201", "202", "204", "209"],
    "204": ["201", "203", "205"],
    "205": ["204", "206", "207"],
    "206": ["205", "207"],
    "207": ["205", "206", "208"],
    "208": ["207"],
    "209": ["202", "203", "206", "211", "210"],
    "210": ["209", "211"],
    "211": ["209", "210", "212"],
    "212": ["211"],
    "301": ["302", "303", "304"],
    "302": ["301", "303", "306", "308"],
    "303": ["301", "302", "304", "308", "316"],
    "304": ["301", "303", "316", "305"],
    "305": ["304", "316", "318"],
    "306": ["302", "307", "308"],
    "307": ["306", "312", "310", "314"],
    "308": ["302", "306", "303", "309", "316", "317"],
    "309": ["317", "308", "314"],
    "310": ["307", "312", "311"],
    "311": ["310", "312", "315", "313"],
    "312": ["307", "314", "310", "311", "315"],
    "313": ["315", "311"],
    "314": ["309", "317", "318", "315", "312"],
    "315": ["313", "311", "314", "312", "318"],
    "316": ["304", "305", "317", "308", "303"],
    "317": ["309", "316", "318", "314"],
    "318": ["305", "316", "317", "314", "315"],
    "401": ["402", "403"],
    "402": ["401", "403", "404", "405"],
    "403": ["401", "402", "404", "405"],
    "404": ["403", "402", "405", "406", "409"],
    "405": ["404", "406", "403"],
    "406": ["404", "405"],
    "407": ["411", "408"],
    "408": ["407", "411", "413", "412"],
    "409": ["410", "412", "405"],
    "410": ["409", "412"],
    "411": ["407", "408", "413"],
    "412": ["410", "409", "408", "413"],
    "413": ["411", "408", "412"],
    "414": ["413"],
    "501": ["502"],
    "502": ["501", "503"],
    "503": ["502"]
  };